import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';
import { InboxProvider } from './context/InboxContext';
import { api } from './lib/api';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminBar from './components/AdminBar';
import Home from './pages/Home';
import MassTimes from './pages/MassTimes';
import Sacraments from './pages/Sacraments';
import SacramentDetail from './pages/SacramentDetail';
import ParishLife from './pages/ParishLife';
import Ministries from './pages/Ministries';
import MinistryDetail from './pages/MinistryDetail';
import ParishCalendarPage from './pages/ParishCalendarPage';
import NewsLinks from './pages/NewsLinks';
import BecomingCatholic from './pages/BecomingCatholic';
import FuneralPlanning from './pages/FuneralPlanning';
import ImNew from './pages/ImNew';
import HallRental from './pages/HallRental';
import Bulletin from './pages/Bulletin';
import About from './pages/About';
import GiveOverview from './pages/GiveOverview';
import GiveOnline from './pages/GiveOnline';
import GiveAutomatic from './pages/GiveAutomatic';
import GiveEnvelopes from './pages/GiveEnvelopes';
import Contact from './pages/Contact';
import NewParishioner from './pages/NewParishioner';
import PrayerRequest from './pages/PrayerRequest';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Oktoberfest from './pages/Oktoberfest';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// Track one anonymous visit per browser session (deduped via sessionStorage).
// Runs once on the very first mount and never again in that tab.
const VisitorTracker = () => {
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || !window.sessionStorage) return;
      if (sessionStorage.getItem('asvi-visit-tracked') === '1') return;
      sessionStorage.setItem('asvi-visit-tracked', '1');
      api.trackVisit().catch(() => { /* silent — visit tracking never blocks the UI */ });
    } catch { /* silent */ }
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <InboxProvider>
            <ScrollToTop />
            <VisitorTracker />
            <AdminBar />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/mass-times" element={<MassTimes />} />
                <Route path="/sacraments" element={<Sacraments />} />
                <Route path="/sacraments/:slug" element={<SacramentDetail />} />
                <Route path="/parish-life" element={<ParishLife />} />
                <Route path="/parish-life/im-new" element={<ImNew />} />
                <Route path="/parish-life/hall-rental" element={<HallRental />} />
                <Route path="/parish-life/ministries" element={<Ministries />} />
                <Route path="/parish-life/ministries/moas/oktoberfest" element={<Oktoberfest />} />
                <Route path="/parish-life/ministries/:slug" element={<MinistryDetail />} />
                <Route path="/parish-life/calendar" element={<ParishCalendarPage />} />
                <Route path="/parish-life/news" element={<NewsLinks />} />
                <Route path="/parish-life/becoming-catholic" element={<BecomingCatholic />} />
                <Route path="/parish-life/funeral" element={<FuneralPlanning />} />
                <Route path="/bulletin" element={<Bulletin />} />
                <Route path="/about" element={<About />} />
                <Route path="/give" element={<GiveOverview />} />
                <Route path="/give/online" element={<GiveOnline />} />
                <Route path="/give/automatic" element={<GiveAutomatic />} />
                <Route path="/give/envelopes" element={<GiveEnvelopes />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/new-parishioner" element={<NewParishioner />} />
                <Route path="/prayer-request" element={<PrayerRequest />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </main>
            <Footer />
            <Toaster />
            </InboxProvider>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
